import { render, staticRenderFns } from "./DelAc.vue?vue&type=template&id=c83fae18&"
import script from "./DelAc.vue?vue&type=script&lang=js&"
export * from "./DelAc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports